// Profile data mirrored from soheelgadad.json (kept in src so CRA can bundle it)

const profile = {
  basics: {
    name: "Soheel Majid Gadad",
    role: "Cloud & DevOps Engineer",
    email: "soheelgadad16@gmail.com",
    phoneDisplay: "+91 7498814658",
    whatsapp: "https://wa.me/917498814658?text=Hi%20Soheel!%20I%20have%20a%20project%20in%20mind.",
    location: "Ponda, Goa, India",
    experience: "2.8 Yrs Experience",
    summary:
      "Highly motivated IT professional with a strong foundation in system administration and modern application deployment. Eager to create scalable, automated, and secure enterprise solutions.",
  },
  socials: {
    github: "https://github.com/SoheelGadad",
    linkedin: "https://www.linkedin.com/in/soheel-gadad",
    twitter: "https://twitter.com/16Soheel",
    instagram: "https://www.instagram.com/c_o_d_e_cracker",
  },
  skills: [
    {
      category: "Cloud Platforms & Architecture",
      items: [
        "AWS (EC2, S3)",
        "Azure (App & SQL)",
        "GCP (Compute & Storage)",
        "Docker",
        "Terraform / IaC",
        "CloudFormation",
        "CI/CD",
        "Git",
      ],
    },
    {
      category: "Scripting & Automation",
      items: [
        "Bash/Shell",
        "Windows Batch",
        "Python",
        "JavaScript",
        "Java",
      ],
    },
    {
      category: "Networking & Servers",
      items: [
        "Windows Server (2019/2022)",
        "Ubuntu / Debian",
        "Active Directory & GPO",
        "TCP/IP / DNS / DHCP",
        "RAID & Virtualization",
      ],
    },
    {
      category: "Development & Databases",
      items: [
        "MERN Stack",
        "React.js",
        "Node.js / Express",
        "MongoDB/MySQL",
      ],
    },
  ],
  experience: [
    {
      role: "Desktop Support Engineer",
      company: "Wipro Technologies Ltd",
      context: "HDFC Bank Project | Primus Global Payroll",
      period: "Dec 2023 – Present",
      points: [
        "Resolved high-priority infrastructure incidents using ServiceNow, maintaining strict SLA compliance.",
        "Managed network operations including LAN troubleshooting, DHCP/DNS, and Active Directory user administration.",
        "Administered Windows/Ubuntu servers and performed end-to-end hardware lifecycle management.",
      ],
    },
    {
      role: "Hardware/Technical Support Engineer",
      company: "Net Tech Services India Pvt. Ltd",
      context: "Union Bank of India",
      period: "Jun 2023 – Dec 2023",
      points: [
        "Diagnosed and resolved complex enterprise hardware and software issues.",
        "Delivered dedicated technical support and client customer service ensuring high end-user satisfaction.",
      ],
    },
    {
      role: "Full Stack Developer Intern",
      company: "Enigmasoft Technologies Pvt. Ltd",
      context: "Café Era Table Booking System",
      period: "30 Days Internship",
      points: [
        "Developed full-stack front-end and back-end logic for the 'Café Era' table booking system.",
      ],
    },
  ],
  projects: [
    {
      name: "Cloud IT Asset Manager",
      icon: "FaCloud",
      color: "#3b82f6",
      tech: ["MERN", "Azure", "RBAC", "CI/CD"],
      description:
        "Architected a scalable, role-based cloud database to replace legacy spreadsheet tracking, establishing a single source of truth.",
      url: "https://assetmanagementsystem-hkdfe0dzd9gchkbj.centralindia-01.azurewebsites.net/",
    },
    {
      name: "Private Storage Server",
      icon: "FaServer",
      color: "#10b981",
      tech: ["Networking", "Hardware", "RAID"],
      description:
        "Designed and implemented a centralized 2TB storage server architecture to facilitate seamless data sharing across multiple workstations.",
      url: null,
    },
    {
      name: "Sweet's Paradise (e-commerce)",
      icon: "FaShoppingCart",
      color: "#f59e0b",
      tech: ["Wix", "E-commerce"],
      description:
        "Developing a website for selling online sweets with a dynamic storefront and checkout.",
      url: "https://khankk4916.wixsite.com/sweetparadise2",
    },
    {
      name: "Café Era (Table booking)",
      icon: "FaUtensils",
      color: "#8b5cf6",
      tech: ["React", "Node.js"],
      description:
        "Full-stack table booking system letting users reserve tables and pick cafe locations.",
      url: "https://client-9x38.onrender.com/",
    },
    {
      name: "Portfolio website",
      icon: "FaCode",
      color: "#3b82f6",
      tech: ["React", "CSS"],
      description:
        "This portfolio — a self-developed website for personal branding and growth.",
      url: "https://soheelgadad-portfolio.onrender.com/",
    },
  ],
  education: [
    {
      degree: "Master of Computer Applications",
      institution: "Chandigarh University",
      period: "2026 | 8.65 CGPA",
      badge: "2026 | 8.65 CGPA",
    },
    {
      degree: "Bachelor of Computer Applications",
      institution: "S.P.E. S's Goa Multi-Faculty College",
      period: "2023 | 7.74 CGPA",
      badge: "2023 | 7.74 CGPA",
    },
    {
      degree: "Higher Secondary School Certificate",
      institution: "GVM's SNJA Higher Secondary School",
      period: "2020 | 56%",
      badge: "2020 | 56%",
    },
    {
      degree: "Secondary School Certificate",
      institution: "A.J. De Almeida High School",
      period: "2018 | 41%",
      badge: "2018 | 41%",
    },
  ],
  certifications: [
    { name: "Azure Core Architectural Components", icon: "FaMicrosoft", color: "#3b82f6" },
    { name: "Gen AI Training (L1, L2, L3)", icon: "FaRobot", color: "#10b981" },
    { name: "HackerRank JavaScript Basic", icon: "SiJavascript", color: "#f59e0b" },
    { name: "UI/UX Design (Figma)", icon: "SiFigma", color: "#f43f5e" },
    { name: "Harvard Team Management", icon: "FaUsers", color: "#8b5cf6" },
  ],
};

export default profile;